module.exports = "/_next/static/images/dollar-line-d10c6d299d43351fa3391d0e8882c7dc.svg";